// import { canNavigate } from '@/libs/acl/routeProtection'
// import { isUserLoggedIn,getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'

import { signalAbortController } from '@/services/controllers'

import store from '@/store/index'

export const projectIdKey = 'projectId'
export const organizationIdKey = 'organizationId'

export function getCurrentProjectId() {
  return store.state.app.projectId
}

export function setCurrentProjectId(id) {
  store.commit('app/SET_PROJECT_ID', id)
}

export function getCurrentOrganizationId() {
  return store.state.app.organizationId
}

export function setCurrentOrganizationId(id) {
  store.commit('app/SET_ORGANIZATION_ID', id)
}

export async function fetchProject(id) {
  return new Promise((resolve, reject) => {
    store
      .dispatch('projects/getProjectByIdWithoutOrganization', id)
      .then(({ data }) => {
        if (data.result.id && data.result.organizationId) {
          resolve(data.result)
        }
        resolve(null)
      })
      .catch(err => reject(err))
  })
}

export function prepRoute(router) {
  router.beforeEach(async (to, from, next) => {
    store.commit('app/SET_PREVIOUS_ROUTE_NAME', from.name)
    if (
      to.meta.noOrganizationAccess
      || to.meta.isPublic
      || to.params.organizationId
      || to.params.projectId
    ) {
      store.commit('app/SET_DEFAULT_USER', false)
    }
    signalAbortController()
    return next()
  })
}

export function routerGuards(router) {
  router.beforeEach(async (to, from, next) => {
    if (to.meta.userProfile) {
      if (getCurrentOrganizationId() && !to.params.organizationId) {
        return next({
          ...to,
          params: {
            ...to.params,
            organizationId: getCurrentOrganizationId(),
            projectId: getCurrentProjectId(),
          },
        })
      }
      if (!getCurrentOrganizationId() && to.params.organizationId) {
        setCurrentOrganizationId(to.params.organizationId)
      }
      if (!getCurrentProjectId() && to.params.projectId) {
        setCurrentProjectId(to.params.projectId)
      }
      return next()
    }

    if (to.params.organizationId) {
      try {
        if (getCurrentOrganizationId() !== to.params.organizationId) {
          setCurrentOrganizationId(to.params.organizationId)
          if (to.params.projectId) {
            setCurrentProjectId(to.params.projectId)
          }
        }
        if (to.name === 'project') {
          setCurrentProjectId(null)
          return next()
        }
        if (getCurrentProjectId() && !to.params.projectId) {
          return next({
            ...to,
            params: {
              ...to.params,
              organizationId: getCurrentOrganizationId(),
              projectId: getCurrentProjectId(),
            },
          })
        }
        return next()
      } catch {
        return next({ ...to, name: 'organization' })
      }
    }

    if (getCurrentOrganizationId() && to.meta.organizationRequired) {
      return next({
        ...to,
        params: {
          ...to.params,
          organizationId: getCurrentOrganizationId(),
          projectId: getCurrentProjectId(),
        },
      })
    }

    if (getCurrentOrganizationId() && to.meta.organizationAccess) {
      return next({
        ...to,
        params: {
          ...to.params,
          organizationId: getCurrentOrganizationId(),
          projectId: getCurrentProjectId(),
        },
      })
    }

    if (to.params.projectId && getCurrentProjectId() !== to.params.projectId) {
      try {
        const result = await fetchProject(to.params.projectId)
        if (result) {
          if (result.organizationId !== getCurrentOrganizationId()) {
            setCurrentOrganizationId(result.organizationId)
          }
          setCurrentProjectId(to.params.projectId)
          store.commit('app/UPDATE_PROJECT_KEY')
        } else {
          return next({ ...to, name: 'project', params: { projectId: null } })
        }
      } catch (err) {
        let errorName = ''
        const statusCode = err.response?.status
        switch (statusCode) {
          case 400:
            errorName = 'error-400'
            break
          case 403:
            errorName = 'error-403'
            break
          case 409:
            errorName = 'error-409'
            break
          case 500:
            errorName = 'error-500'
            break
          case 503:
            errorName = 'error-403'
            break
          default:
            errorName = 'error-404'
        }
        return next({ name: errorName })
      }
    }

    if (!to.params.projectId && to.meta.projectRequired) {
      if (!getCurrentProjectId()) {
        if (from.meta.organizationAccess) {
          return next({ ...to, name: 'project', params: { projectId: null } })
        }
        return next({ ...to, name: 'set-user', params: { nextRoute: to.name } })
      }
      return next({
        ...to,
        params: { ...to.params, projectId: getCurrentProjectId() },
      })
    }

    // // Redirect if logged in
    // if (to.meta.redirectIfLoggedIn) {
    //   const userData = getUserData()
    //   return next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
    // }
    return next()
  })
}
